import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import { pagesRoute, publicRoutes } from "./router.link";
import { Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ThemeSettings from "../InitialPage/themeSettings";
import Swal from "sweetalert2";
import { restoreAuth, useAutoLogout,getProfile } from "../core/api/auth";
import ProtectedRoute from "./protected_route";
import PermissionRoute from "./permission_route";

const HeaderLayout = () => {
  const data = useSelector((state) => state.toggle_header);

  return (
    <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
      <Header />
      <Sidebar />
      <Outlet />
      <ThemeSettings />
    </div>
  );
};

const Authpages = () => {
  const data = useSelector((state) => state.toggle_header);
  
  return <div className={data ? "header-collapse" : ""}>
    <Outlet />
    {/* <Loader /> */}
  </div>
}

const AllRoutes = () => {
  console.log("AllRoutes rendering");
  const { isAuthenticated } = useSelector((state) => state.auth || {});
  const permissions = useSelector((state) => state.permissions || {});
  const dispatch = useDispatch();
  useAutoLogout();
  
  // Restore authentication on component mount
  useEffect(() => {
    console.log("[Router] Restoring auth state");
    dispatch(restoreAuth());
  }, [dispatch]);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const profile = await dispatch(getProfile());
        console.log("[Router] Fetched user profile:", profile); // Here, 'profile' is the actual response object
      } catch (error) {
        console.error("[Router] Error fetching user profile:", error);
      }
    };

    if (isAuthenticated) {
      fetchUserProfile();
    }
  }, [isAuthenticated, dispatch]);


  
  // Debug authentication and permissions state
  useEffect(() => {
    console.log("[Router] Auth state changed:", { isAuthenticated });
    console.log("[Router] Permissions state:", { 
      loaded: permissions.loaded,
      role: permissions.role,
      routesCount: permissions.routes?.length || 0 
    });
  }, [isAuthenticated, permissions]);

  return (
    <div>
      <Routes>        
        {/* Root path redirect based on authentication status */}
        <Route 
          path="/" 
          element={
              <ProtectedRoute>
                <PermissionRoute>
                  <HeaderLayout />
                </PermissionRoute>
              </ProtectedRoute>
          }
        />

        {/* Protected routes with header and sidebar */}
        <Route
          element={
            <ProtectedRoute>
              <PermissionRoute>
                <HeaderLayout />
              </PermissionRoute>
            </ProtectedRoute>
          }
        >
          {publicRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

        {/* Auth pages (signin, etc.) */}
        <Route path={"/"} element={<Authpages />}>
          {pagesRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
      </Routes>
    </div>
  );
};
export default AllRoutes;
